import React from 'react';
import Hero from '../components/Hero';
import ReferencesBanner from '../components/ReferencesBanner';
import ServicesBanner from '../components/ServicesBanner';
import PPCSection from '../components/PPCSection';
import ProductImagesSection from '../components/ProductImagesSection';
import SEOSection from '../components/SEOSection';
import PortfolioTeaser from '../components/PortfolioTeaser';
import LinkedInPreview from '../components/LinkedInPreview';
import StatsSection from '../components/StatsSection';
import ComparisonSection from '../components/ComparisonSection';
import CaseStudies from '../components/CaseStudies';
import Testimonials from '../components/Testimonials';
// import RefBanner from '../components/RefBanner';
import CustomerLogos from '../components/CustomerLogos';
import FeaturedTestimonials from '../components/FeaturedTestimonials';
import TeamSection from '../components/TeamSection';
import FAQ from '../components/FAQ';
import './MainPage.css';

const MainPage = () => {
  return (
    <div className="main-page-fox">
      <Hero />
      <ReferencesBanner />
      <ServicesBanner />
      <PPCSection />
      <ProductImagesSection />
      <PortfolioTeaser />
      <SEOSection />
      <LinkedInPreview />
      <StatsSection />
      <ComparisonSection />
      <CaseStudies />
      <Testimonials />
      {/* <RefBanner /> */}
      <CustomerLogos />
      <FeaturedTestimonials />
      <TeamSection />
      <FAQ />
    </div>
  );
};

export default MainPage;

